var React = require('react');

function Mobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22,2H10A3.00328,3.00328,0,0,0,7,5V27a3.00328,3.00328,0,0,0,3,3H22a3.00328,3.00328,0,0,0,3-3V5A3.00328,3.00328,0,0,0,22,2ZM10,4H22a1.001,1.001,0,0,1,1,1V6H9V5A1.001,1.001,0,0,1,10,4ZM23,8V24H9V8ZM22,28H10a1.001,1.001,0,0,1-1-1V26H23v1A1.001,1.001,0,0,1,22,28Z"}));
}

Mobile.defaultProps = {"viewBox":"0 0 32 32","id":"ki-mobile-f"};

module.exports = Mobile;

Mobile.default = Mobile;
